/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Create_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not create referral code." |
*
* @param {Partner_Referral_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_create_error = /** @type {((inputs?: Partner_Referral_Create_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Create_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Empfehlungscode konnte nicht erstellt werden.")
	return /** @type {LocalizedString} */ ("Could not create referral code.")
});